import { graphql } from '../../../../../../globals/api/requests';

export const fetchSotyCategories = (year: number) => {
  return graphql(
    `
      query sotyPage($year: Int) {
        shopOfTheYear(year: $year) {
          year
          categories {
            nodes {
              id
              name
              resourceName
              isSpecial
              mainAward
              logo
              winner {
                id
                name
                pathName
                hasLogo
                featured
                userReviewSummary {
                  rating
                  count
                  countTotal
                }
              }
            }
          }
        }
      }
    `,
    { year }
  );
};
